import { DateTime } from 'luxon';

/** UTC, like every other dashboard boundary — see `src/constants/dashboard`. */
export const NOW = DateTime.utc();

export const MIN_DATE = DateTime.fromISO('2023-01-01', { zone: 'utc' });

export const MIN_DATE_WORK_LETTER_REPORT = DateTime.fromISO('2026-07-01', { zone: 'utc' });

export enum DashboardFilterFormField {
  employers = 'employers',
}
